import { Divider, Hidden, Link } from "@material-ui/core";
import { HomeboundLogo } from "src/components/Icons/HomeboundLogo";
import { Typography } from "src/components/Typography";
import { Css, Palette } from "src/Css";
import { careEmail } from "src/email";
import { HomeownerPalette } from "src/theme/palettes";

export function SignInFooter() {
  return (
    <div css={Css.pb4.pt4.df.bgColor(HomeownerPalette.Blue).$}>
      <div css={Css.pl4.fg1.$}>
        <div css={Css.pb2.$}>
          <HomeboundLogo width={126} height={21} color={HomeownerPalette.White} />
        </div>
        <Typography size="f14" color={HomeownerPalette.White} lineHeight={20}>
          © Homebound Inc. {new Date().getFullYear()}
        </Typography>
      </div>
      <Hidden smUp>
        <div css={Css.pt2.pb4.$}>
          <Divider />
        </div>
      </Hidden>
      <ContactUs />
    </div>
  );
}

function ContactUs() {
  return (
    <div css={Css.df.pr8.pl4.aifs.$}>
      <Typography size="f14" color={Palette.Gray400}>
        Need help?
      </Typography>
      <Link href={`mailto:${careEmail}`} css={Css.ml1.onHover.tdn.add("borderBottom", "1px solid white").pbPx(2).$}>
        <Typography size="f14" color={Palette.White}>
          Contact us.
        </Typography>
      </Link>
    </div>
  );
}
